import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import ClaytonLogo from '@components/Shared/ClaytonLogo/ClaytonLogo';
import { formatShortDate, truncateText } from '@utils/formatters';
import { PressReleaseCardStyles } from './PressReleaseCard.styled';
import { prefixRoute } from '@utils/newsroomUtils';
import { formatHttpsUrl } from '@utils/utils';

const PressReleaseCard = ({ pressRelease }) => {
  const mediaUrl =
    (pressRelease.featuredMedia &&
      pressRelease.featuredMedia.media &&
      formatHttpsUrl(
        pressRelease.featuredMedia.media.url + '?h=200&fm=webp'
      )) ||
    '';

  const mediaAltText =
    (pressRelease.featuredMedia &&
      pressRelease.featuredMedia.media &&
      pressRelease.featuredMedia.media.altText) ||
    pressRelease.featuredMediaTitle;

  return (
    <PressReleaseCardStyles>
      <a href={prefixRoute(pressRelease.slug)} target="_blank" rel="noreferrer">
        <div className="pr-media">
          {mediaUrl ? (
            <Image alt={mediaAltText} src={mediaUrl} width={244} height={165} />
          ) : (
            <div className="pr-media-none">
              <ClaytonLogo />
            </div>
          )}
        </div>
        <div className="pr-header">
          <h6>{pressRelease.categories[0]}</h6>
          <h6>{formatShortDate(pressRelease.publicationDate)}</h6>
        </div>
        <h5>{truncateText(pressRelease.headline, 96)}</h5>
      </a>
    </PressReleaseCardStyles>
  );
};

PressReleaseCard.propTypes = {
  pressRelease: PropTypes.shape({
    categories: PropTypes.any,
    featuredMedia: PropTypes.shape({
      media: PropTypes.shape({
        altText: PropTypes.any,
        url: PropTypes.string,
      }),
    }),
    featuredMediaTitle: PropTypes.any,
    headline: PropTypes.any,
    publicationDate: PropTypes.any,
    slug: PropTypes.any,
  }),
};

export default PressReleaseCard;
